<template>
    <div class="panel panel-default panel-dashboard">
        <div v-if="data !== null" class="panel-body">
            <table class="table table-striped table-condensed">
                <thead>
                <tr>
                    <th class="col-xs-5">
                        <a href="#" @click.prevent="sort('user_full_name')">
                            User <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-4">
                        <a href="#" @click.prevent="sort('total_count')">
                            Opportunities <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-5">
                        <a href="#" @click.prevent="sort('converted_count')">
                            Conversions <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-5">
                        <a href="#" @click.prevent="sort(selectedMetrics.first)">
                            {{ metrics.find(metric => metric.value === selectedMetrics.first).label }} <i class="fa fa-sort"></i>
                        </a>
                    </th>

                    <th class="col-xs-5">
                        <a href="#" @click.prevent="sort(selectedMetrics.second)">
                            {{ metrics.find(metric => metric.value === selectedMetrics.second).label }} <i class="fa fa-sort"></i>
                        </a>
                    </th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="row in sortedData">
                    <td>
                        {{ row.user_full_name }}
                    </td>

                    <td>
                        {{ row.closed_count }} / {{ row.total_count }}
                    </td>

                    <td>
                        {{ row.converted_count }} ({{ getConversionRate(row) }} %)
                    </td>

                    <td>
                        {{ row[selectedMetrics.first] | price }}
                    </td>

                    <td>
                        {{ row[selectedMetrics.second] | price }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        props: {
            filters: {
                required: true,
                type: Object
            },

            selectedMetrics: {
                required: true,
                type: Object
            },

            metrics: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                data: null,

                sortDirection: null,
                sortColumn: null
            }
        },

        mounted() {
            this.load()
        },

        watch: {
            filters: {
                deep: true,
                handler: function () {
                    this.load()
                }
            }
        },

        computed: {
            sortedData() {
                let sorted = [...this.data]

                sorted.sort((a, b) => {
                    if (!this.sortColumn) {
                        return 0
                    }

                    if (this.sortDirection === 'asc') {
                        return a[this.sortColumn] > b[this.sortColumn] ? 1 : -1
                    }

                    return a[this.sortColumn] > b[this.sortColumn] ? -1 : 1
                })

                return sorted
            }
        },

        methods: {
            load() {
                http.post('/api/v1/reports/opportunity-by-user', this.filters)
                    .then(response => {
                        this.data = response.data.data
                    })
            },

            getConversionRate(row) {
                if (row.closed_count === 0) {
                    return 'N/A'
                }

                return Math.round(row.converted_count / row.closed_count * 100)
            },

            sort(column) {
                if (this.sortColumn === column) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
                } else {
                    this.sortDirection = 'desc'
                }

                this.sortColumn = column
            }
        }
    }
</script>
